export const TEXTS = {
    GREEN_SHIP: "Get your orders together in fewer boxes and deliveries.",
    DISABLED_GREEN_SHIP: "This item will be removed from the Greenship program and shipped out of cycle, in accordance with distributions shipping policies."
}
